/* tslint:disable:component-selector import-spacing no-trailing-whitespace no-inferrable-types */

import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit
}                                         from '@angular/core';

import {
  Observable,
  Subscriber,
  Subscription
}                                         from 'rxjs';

import {ResizeObserver}                   from "resize-observer";
import { Theme }                          from '@/models/appearence/theme';
import { ConnectionViewerConfigService }  from '@/services/connection.viewer.config.service';
import { ConnectionViewerConfiguration }  from '@/models/connection.viewer.configuration';
import { Logger }                         from '@/util/logger'
import { errorAsText }                    from '@/util/util';
import {
  basename,
  empty
}                                         from '@/util/util';
import { DecisionPoint }                  from '@/models/scenario/decision.point';
import {
  LinkBlock,
  LinkBlockOrientation
}                                    from '@/screens/ide/connectionviewer/link.block';
import { Port }                      from '@/screens/ide/connectionviewer/port';
import {
  Track,
  TrackType
}                                    from '@/models/scenario/track';
import { Connection as Route }       from '@/screens/ide/connectionviewer/connection';
import { HighLightManager }          from '@/screens/ide/connectionviewer/high.light.manager';
import { KonvaCanvas }               from '@/screens/ide/connectionviewer/konva/konva.canvas';
import { TrainDirection }            from '@/models/scenario/train.class';
import { KeyboardListenerInterface } from '@/screens/ide/connectionviewer/keyboard.listener.interface';
import { Scenario }                  from '@/models/scenario/scenario';

import * as $ from 'jquery';

import 'gasparesganga-jquery-loading-overlay'; /* https://gasparesganga.com/labs/jquery-loading-overlay/ */

@Component({
  selector: 'connection-viewer-component',
  template: `
      <!-- outer shell for the  browser tabs -->
      <div
              [style.--wrapper-bg-color]="theme().wrapper_background_color"
              [style.--wrapper-fg-color]="theme().wrapper_foreground_color"
              [style.--canvas-bg-color]="theme().canvas_background_color"
              [style.--canvas-fg-color]="theme().canvas_foreground_color"
              [style.--fg-color]="dark ? 'white' : 'black'"
              [style.--bg-color]="dark ? 'black' : 'white'"

              class="connection-viewer-shell" style="text-align:center">

      <!--suppress CssUnknownProperty -->
      <div
              id="connection-viewer-wrapper-{{u}}" class="connection-viewer-wrapper">

          <!-- drag and drop overlay -->

          <div id="connection-viewer-drag-and-drop-{{u}}" class="connection-viewer-drag-and-drop">

              <div style="z-index: 1006;" class="connection-viewer-table">
                  <div class="connection-viewer-table-cell">
                      <h1>DROP FILE HERE</h1>
                  </div>
              </div>

              <div style="z-index: 1005;" class="connection-viewer-table">
                  <div class="connection-viewer-table-cell">
                      <div class="connection-viewer-caution"></div>
                  </div>
              </div>

          </div>

          <!-- top level overlay -->

          <div id="connection-viewer-overlay-{{u}}" class="connection-viewer-overlay">

          </div>

          <!-- spike lines / dynamic display stuff -->
          <canvas id="connection-viewer-hud-{{u}}" class="connection-viewer-hud">

          </canvas>

          <section

                  id="connection-viewer-canvas-{{u}}" tabIndex=1 class="connection-viewer-canvas">

          </section>

          <div id="connection-viewer-command-bar_{{u}}" class="connection-viewer-command-bar">

              <!-- the decision point picker -->

              <p-dropdown
                      [options]="decisionPoints"
                      [(ngModel)]="selectedDP"
                      optionLabel="_name"
                      filterBy="_name"
                      dataKey="_id"
                      [autoDisplayFirst]="true"
                      id="connection-viewer-dp-picker_{{u}}"
                      class="connection-viewer-dp-picker"

                      (onChange)="dpChangeEvent()"
              >

                  <ng-template pTemplate="selectedItem">

                      <div class="flex align-items-center gap-2" *ngIf="selectedDP">
                          <div>{{ selectedDP._name }} - {{ selectedDP._mileage }}</div>
                      </div>

                  </ng-template>

                  <ng-template let-dp pTemplate="item">

                      <div class="flex align-items-center gap-2">
                          <div>{{ dp._name }} - {{ dp._mileage }}</div>
                      </div>

                  </ng-template>

              </p-dropdown>

              <p-button
                      title="Toggle Speed Coloring ON/OFF"
                      (onClick)="toggleColoring()"
                      (mouseover)="speedButtonHover = true"
                      (mouseout)="speedButtonHover = false"
                      class="connection-viewer-speed-toggle"
                      [class.speed-enabled]="colorSpeed">
                  <img ngSrc="../assets/images/speed-icon-20.png" height="20" width="17" title="Speed Toggle" alt="Speed Toggle">
              </p-button>

              <div [class.popped]="speedButtonHover" class="connection-viewer-speed-legend">
                  <span class="legend-title">Speed Legend (MPH)</span>
                  <ul>
                      <li><div class="color-sample grey"></div><div class="legend-text">0 (unlimited)</div></li>
                      <li><div class="color-sample red"></div><div class="legend-text">1-15</div></li>
                      <li><div class="color-sample yellow"></div><div class="legend-text">16-30</div></li>
                      <li><div class="color-sample green"></div><div class="legend-text">31-45</div></li>
                      <li><div class="color-sample magenta"></div><div class="legend-text">46+</div></li>
                  </ul>
              </div>
          </div>

      </div>
      </div>
  `,
  styles: [
    `
      :host {
        width: 100%;
        height: 100%;
        display: block;
        margin: 0;
        padding: 0;
        text-align: right;
      }

      /* wrapping container for everything */

      div.connection-viewer-wrapper {

        background-color: var(--wrapper-bg-color);
        color: var(--wrapper-fg-color);
        position: relative;
        width: 100%;
        height: 100%;
        display: block;
        margin: 0;
        padding: 0;
      }

      /* drag and drop */

      div.connection-viewer-drag-and-drop {

        position: absolute;
        display: block;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: var(--canvas-bg-color);
        z-index: 1003;

        pointer-events: none;
      }

      div.connection-viewer-table {
        display: table;
        position: absolute;
        table-layout: fixed;
        width: 100%;
        height: 100%;
      }

      div.connection-viewer-table-cell {
        display: table-cell;
        width: 100%;
        height: 100%;
        text-align: center;
        vertical-align: middle;
      }

      div.connection-viewer-drag-and-drop h1 {

        display: inline-block;
        color: #868686;
        font-family: "HelveticaNeue-Light", "Helvetica Neue Light", "Helvetica Neue",
        Helvetica, Arial, "Lucida Grande", sans-serif;
        font-size: 42px;
        font-weight: bolder;
        background-color: var(--canvas-bg-color);
        padding: 20px;
      }

      div.connection-viewer-caution {
        display: inline-block;
        width: 100%;
        height: 28px;
        background: repeating-linear-gradient(
          45deg,
          #B4B4B4FF,
          #B4B4B4FF 20px,
          var(--canvas-bg-color) 20px,
          var(--canvas-bg-color) 40px
        );
      }

      .connection-viewer-dragging {
        background-color: #254b28 !important;
      }

      /* top level overlay */

      div.connection-viewer-overlay {

        position: absolute;
        display: none;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: transparent;
        z-index: 1002;

        /* specific children will accept events */

        pointer-events: none;
      }

      /* the spike lines overlay */

      .connection-viewer-hud {

        position: absolute;
        display: none;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: transparent;
        z-index: 1002;

        /* specific children will accept events */

        pointer-events: none;
      }

      /* the actual rendering canvas */

      .connection-viewer-canvas {

        background-color: var(--canvas-bg-color);
        color: var(--canvas-fg-color);

        width: 100%;
        height: 100%;
        display: block;
        z-index: 1000;
      }

      .connection-viewer-command-bar {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
        height: 64px;
        width: 100%;
      }

      .connection-viewer-command-bar.day {
        background-color: rgba(255, 255, 255, .4);
      }

      .connection-viewer-command-bar.night {
        background-color: rgba(0, 0, 255, .4);
      }

      .connection-viewer-dp-picker {
        position: absolute;
        left: 64px;
        top: 6px;
      }
    `
    ]

})

export class ConnectionViewerComponent implements OnInit, AfterViewInit, OnDestroy, KeyboardListenerInterface  {

  /** for uniq'ifying our drop #id's */

  public static  instanceNum: number              = 0;
  public u: number                                = ConnectionViewerComponent.instanceNum;

  /** hint for window title, whatever we have for the basename of the scenario file */
  public        fileName: string                  = '';

  /** the current scenario model */
  public       scenario: Scenario                 = null;

  /** the object version of the JSON used to load the scenario */
  public           json: any;

  /** blob key of scenario if it was loaded from a blob */
  public    scenarioKey:          string          = '';

  /** the decision point to focus on */
  public decisionPoint: string                    = '';

  /** enable debugging mode */
  public debug: boolean                           = false;

  /** enable a grid */
  public grid: boolean                            = false;

  /** enable dark mode */
  public dark: boolean                            = true;

  /** which light theme are using (for light mode) */
  public lightTheme: string                       = 'light1';

  /** which dark theme are we using (for dark mode) */
  public darkTheme: string                        = 'dark2';

  /** show the spike lines? */
  public spikelines: boolean                      = false;

  /** hover detail around the mouse*/
  public hud: boolean                             = false;

  /** is the HUD mode normal or simple? */
  public simpleHUD: boolean                       = false;

  /** user scale for the horizontal axis */
  public xScale: number                           = 1;

  /** user scale for the vertical axis */
  public yScale: number                           = 1;

  /** the canvas resizing subscription */
  private resizeSubscription: Subscription|null   = null;

  /** subscription for general configuration change events */
  private configSubscription: Subscription|null   = null;

  /** are we drawing overlay/HUG stuff? */
  private notAnimating: boolean                   = true;

  /** the decision points we can choose for viewing connections of */
  public decisionPoints: DecisionPoint[]          = [];

  /** the currently selected decision point */
  public selectedDP: DecisionPoint|null           = null;

  /** the virtual canvas we are working with. */
  public canvas: KonvaCanvas|null                 = null;

  /** the current raw scenario JSON text (if any) */
  private scenarioFile: File|null                 = null;

  /** the east side tracks */
  private eastSide: LinkBlock|null                = null;

  /** the west side tracks */
  private westSide: LinkBlock|null                = null;

  /** the junction tracks */
  private junctions: LinkBlock|null               = null;

  /** the connection web */
  private routes: Map<number, Route>              = new Map<number, Route>();

  /** the current set of highlighted objects (if any) */
  private highlightManager: HighLightManager|null = null;

  /** by default don't color connections by speed */
  public colorSpeed: boolean                      = false;

  /** only true while the mouse is over the coloring mode toggle button */
  public speedButtonHover: boolean                = false;


  /** general call back for when we reload */
  public reloaded: () => void;

  /** standard constructor */
  constructor(
    private configService: ConnectionViewerConfigService
  ) {

    let cv: ConnectionViewerComponent = this;

    Logger.debug(`[ConnectionViewer(${cv.u})] dynamically creating...`);

    cv.configSubscription =
      cv.configService.onChange(cv.u).subscribe((config: ConnectionViewerConfiguration): void => {

        /* pay attention to stuff like debug or dark mode toggling etc. */

        cv.reconfigure(config);

      });
  }

  /** project manager panel is being closed, do any clean up. */
  public close(): void {

    let cv: ConnectionViewerComponent = this;

    Logger.debug(`[ConnectionViewer(${cv.u})] - Closing! ...`);

    cv.clear();

    if (cv.resizeSubscription) {

      cv.resizeSubscription.unsubscribe();

      cv.resizeSubscription = null;
    }

    if (cv.configSubscription) {

      cv.configSubscription.unsubscribe();

      cv.configSubscription = null;
    }

    cv.configService.removeConfiguration(cv.u);

  }

  /** helper to update ourselves to whatever the latest configuration is */
  private reconfigure(config?: ConnectionViewerConfiguration): ConnectionViewerComponent {

    let cv: ConnectionViewerComponent = this;

    if (!cv.configService) {

      /* nothing to do yet */

      return this;
    }

    if (!config) {

      config = cv.configService.getConfiguration(cv.u);
    }

    cv.setHUDMode(this.configService.getHUDMode(cv.u));
    cv.setSpikeLinesMode(this.configService.getSpikeLinesMode(cv.u));
    cv.setFile(this.configService.getFile(cv.u));

    return cv;
  }

  ngOnInit(): void {

    let cv: ConnectionViewerComponent = this;

    Logger.debug(`[ConnectionViewer(${cv.u})] - onInit() ...`);

    if (!cv.debug) {

      cv.debug = false;
    }

    Logger.debug(`[ConnectionViewer(${cv.u})] - initializing debug=${cv.debug}...`);

    /* was debugging enabled? */

    if (cv.debug) {

      Logger.debug(`[ConnectionViewer(${cv.u})] - DEBUG mode enabled.`);

    } else {

      Logger.debug(`[ConnectionViewer(${cv.u})] - PRODUCTION mode enabled.`);
    }

    cv.configService.setDebugMode(cv.u, cv.debug);

    /* did they override dark mode? */

    if (cv.dark) {

      Logger.debug(`[ConnectionViewer(${cv.u})] - DARK mode enabled.`);

    } else {

      Logger.debug(`[ConnectionViewer(${cv.u})] - DARK mode enabled.`);
    }

    cv.configService.setDarkMode(cv.u, cv.dark);

    /* are we showing spike-lines? */

    if (cv.spikelines) {

      Logger.debug(`[ConnectionViewer(${cv.u})] - SPIKES mode enabled.`);

    } else {

      Logger.debug(`[ConnectionViewer(${cv.u})] - SPIKES mode enabled.`);
    }

    cv.configService.setSpikeLinesMode(cv.u, cv.spikelines);

    /* are we showing hte HUD? */

    if (cv.hud) {

      Logger.debug(`[ConnectionViewer(${cv.u})] - HUD mode enabled.`);

    } else {

      Logger.debug(`[ConnectionViewer(${cv.u})] - HUD mode enabled.`);
    }

    cv.configService.setHUDMode(cv.u, cv.hud);

    /* did they override hud render mode? */

    if (cv.grid) {

      Logger.debug(`[ConnectionViewer(${cv.u})] - HUD SIMPLE mode enabled.`);

    } else {

      Logger.debug(`[ConnectionViewer(${cv.u})] - HUD SIMPLE mode enabled.`);
    }

    cv.configService.setHUDSimpleMode(cv.u, cv.grid);

    /* did the override the distance or timescale(s)? */

    if (!cv.xScale) {

      cv.xScale = 1;
    }

    if (!cv.yScale) {

      cv.yScale = 1;
    }

    if (cv.xScale < 0.0001) {

      cv.xScale = 0.0001;
    }

    if (cv.yScale < 0.0001) {

      cv.yScale = 0.0001;
    }

    Logger.debug(`[ConnectionViewer(${cv.u})] - scaling: xScale=${cv.xScale}, yScale=${cv.yScale}.`);

    /* theme choice, for both light and dark modes? */

    cv.configService.setDarkModeTheme(cv.u, Theme.build(cv.darkTheme) ?? Theme.dark());
    cv.configService.setLightModeTheme(cv.u, Theme.build(cv.lightTheme) ?? Theme.light());

    Logger.debug(`[ConnectionViewer(${cv.u})] - theme: dark=${cv.configService.getDarkModeTheme(cv.u).darkMode}, light=${cv.configService.getLightModeTheme(cv.u).lightMode}.`);

    /* rendering mode? */

    cv.configService.setScaleX(cv.u, cv.xScale);
    cv.configService.setScaleY(cv.u, cv.yScale);

    Logger.debug(`[ConnectionViewer(${cv.u})] - initial configuration set.`);

  }

  ngOnDestroy() {

    let cv: ConnectionViewerComponent = this;

    Logger.debug(`[ConnectionViewer(${cv.u})] - onDestroy() ...`);

    if (cv.resizeSubscription) {

      cv.resizeSubscription.unsubscribe();
    }

    if (cv.configSubscription) {

      cv.configSubscription.unsubscribe();
    }
  }

  ngAfterViewInit() {

    let cv: ConnectionViewerComponent = this;

    /* identify this instance */

    cv.u = ConnectionViewerComponent.instanceNum++;

    /* [start] - - - - - -  drag n' drop behaviors - - - - - - - - - - - - */

    /*
     * wire in the drag and drop support, if they try to drop
     * something on the canvas, then take it as a new file to
     * load.
     *
     */

    /* get the scenario drop box */

    const canvasId: string      = `connection-viewer-canvas-${cv.u}`;
    const dragOverlayId: string = `connection-viewer-drag-and-drop-${cv.u}`;

    Logger.debug(`[ConnectionViewer(${cv.u})] - setting up drop zone..., canvas=${canvasId}, drop=${dragOverlayId}, ...`);

    /* get the drop box */

    const dropAreaJQ: JQuery<HTMLElement> = $(`#${canvasId}`);
    const dropArea: HTMLElement|null      = dropAreaJQ.get(0) ?? null;
    const dropOvly: HTMLElement|null      = $(`#${dragOverlayId}`).get(0) ?? null;

    if (dropArea && dropOvly) {

      /* we'll take it from here :) */

      ['dragenter', 'dragover'].forEach(eventName => {

        dropArea.addEventListener(eventName, (e: Event) => {

          e.preventDefault();
          e.stopPropagation();

          /* while they are dragging, show the dragging overlay */

          $(dropOvly).css('display', 'block');

          $(dropOvly).addClass('connection-viewer-dragging');

          cv.notAnimating = true;

        }, false);

      });

      ['dragleave', 'drop'].forEach(eventName => {
        dropArea.addEventListener(eventName, (e: Event) => {

          e.preventDefault();
          e.stopPropagation();

          /* if they leave or drop the file, stop showing the drag and drop overlay */

          /* while they are dragging, show the dragging overlay */

          $(dropOvly).css('display', 'none');

          $(dropOvly).removeClass('connection-viewer-dragging');

          $(`#connection-viewer-hud-${cv.u}`).css('display', 'block');

          cv.notAnimating = false;

          if (!cv.configService.getFile(cv.u)) {

            /* there is no file yet so keep showing the drag n drop area */

            $(dropOvly).css('display', 'block');
          }

        }, false);

      });

      dropArea.addEventListener('drop', (e) => {

        e.preventDefault();
        e.stopPropagation();

        const dt: DataTransfer|null = e.dataTransfer;

        /* they dropped a file! */

        if (!dt) {

          Logger.error(`[ConnectionViewer(${cv.u})] 'drop' - no input file.`);

          return ;
        }

        Logger.debug(`[ConnectionViewer(${cv.u})] dropped: `, dt.files[0]);

        cv.configService.setFile(cv.u, dt.files[0]);

        /* move to showing progress overlay or the actual rendering overlay */

        $(dropOvly).css('display', 'none');

      }, false);

    }

    /* [end] - - - - - -  drag n' drop behaviors - - - - - - - - - - - - */

    /* [start - - - - - -  resize behaviors - - - - - - - - - - - - */

    Logger.debug(`[ConnectionViewer(${cv.u})] - after view init...`);

    cv.resizeSubscription = cv.configService.onResize(cv.u).subscribe((geometry: {width: number, height: number}): void => {

      // Logger.debug(`ConnectionViewer(${cv.u}) - new geometry: width=${geometry.width}, height=${geometry.height}`);

      /* update the virtual canvas */

      cv.canvas?.resize(geometry.width, geometry.height);
    });

    const wrapperId: string      = `connection-viewer-wrapper-${cv.u}`;

    const observer = new ResizeObserver(entries => {

      entries.forEach(entry => {

        /* update the configuration service, which will update any listeners in turn */

        cv.configService.setWidthHeight(cv.u, entry.contentRect.width, entry.contentRect.height);

      });
    });

    let el: Element|null = document.querySelector(`#${wrapperId}`);

    if (el) {

      observer.observe(el);

      /* set initial geometry */

      cv.configService.setWidthHeight(cv.u, el?.clientWidth ?? 0, el?.clientHeight ?? 0);

    } else {

      Logger.error(`[ConnectionViewer(${cv.u})] - no wrapper element??`);

    }

    /* [end] - - - - - -  resize behaviors - - - - - - - - - - - - */

  }

  public toggleColoring(): void {

    let cv: ConnectionViewerComponent = this;

    if (cv.colorSpeed) {

      cv.colorSpeed = false

      Logger.debug(`[ConnectionViewer(${cv.u})] - toggleColoring() ...by DEFAULT`);

      cv.highlightManager?.defaultHighlighting();

    } else {

      cv.colorSpeed = true

      Logger.debug(`[ConnectionViewer(${cv.u})] - toggleColoring() ...by SPEED`);

      cv.highlightManager?.speedHighlighting();
    }

    /* give keyboard focus to the canvas */

    this.canvas?.focus();

  }

  /** update the error line in the loader drop down */
  public status(msg: string =  '') {

    let cv: ConnectionViewerComponent = this;

    Logger.info(`[ConnectionViewer(${cv.u})] ${msg}`);
  }

  /** update the error line in the loader drop down */
  public success(msg: string =  '') {

    let cv: ConnectionViewerComponent = this;

    Logger.debug(`[ConnectionViewer(${cv.u})] ${msg}`);
  }

  /** update the error line in the loader drop down */
  public error(msg: string =  '') {

    let cv: ConnectionViewerComponent = this;

    Logger.error(`[ConnectionViewer(${cv.u})] ${msg}`);
  }

  /** @brief lock user interaction */
  public onScenarioLock(msg: string = '') {

    let cv: ConnectionViewerComponent = this;

    Logger.debug(`[ConnectionViewer(${cv.u})] locking ` + msg);

    // @ts-ignore
    $.LoadingOverlay('show', {
      text: msg,
      background: 'rgba(255, 255, 255, 0.85)',
      textColor: 'black',
      imageColor: 'black'

    });

    // @ts-ignore
    $.LoadingOverlay('text', msg);

  }

  /** @brief unlock user interaction */
  public onScenarioUnlock(msg: string = '') {

    let cv: ConnectionViewerComponent = this;

    Logger.debug(`[ConnectionViewer(${cv.u})] unlocking ` + msg);

    // @ts-ignore
    $.LoadingOverlay('hide');

    // @ts-ignore
    $.LoadingOverlay('text', msg);
  }

  public fromText(text: string, key: string|Scenario = '', dp: string = ''): void {

    let cv: ConnectionViewerComponent = this;

    if (key instanceof Scenario) {

      Logger.debug(`[ConnectionViewer(${cv.u})] direct load scenario (dp='${dp}'): `, key);

    } else {

      Logger.debug(`[ConnectionViewer(${cv.u})] loading from raw text, dp='${dp}', blob key='${key}' ...`);
    }

    cv.decisionPoint = dp;
    cv.json          = null;

    this.fileName    = '';

    /* if they gave us a Scenario object...we can just use that ... */

    if (key instanceof Scenario) {

      /* short circuit to re-using this scenario... */

      cv.scenario      = key;
      cv.fileName      = basename(cv.scenario._tag);
      cv.scenarioKey   = cv.scenario._tag;
      cv.decisionPoint = dp;

      if (!cv.scenario.isReady()) {

        Logger.error(`[ConnectionViewer(${cv.u})] invalid scenario: ` + cv.scenario.getError());
        cv.error(`invalid scenario: ${cv.scenario.getError()}`);

        return ;
      }

      Logger.debug(`[ConnectionViewer(${cv.u})] using scenario dp=${cv.decisionPoint}: `, cv.scenario);

      /* success */

      setTimeout( (): void => {

        cv.setScenario(key, dp)

        /* let any user of this component know that we have reloaded the view */

        cv.reloaded();

      }, 600);

      return ;
    }

    /* ok we have a string for the key, so it's likely a blob key/path */

    cv.scenarioKey   = key;

    if (!empty(key)) {

      cv.fileName = basename(key);
    }

    /* convert to JSON */

    try {

      cv.json = JSON.parse(text);

    } catch (e) {

      Logger.error(`[ConnectionViewer(${cv.u})] Can not parse scenario JSON: ` + e.getError());
      cv.error('Can not parse scenario JSON: ' + e.getError());

      return ;
    }

    /* try to construct a new model */

    cv.onScenarioLock('Building from JSON...');

    const newScenario: Scenario = new Scenario(cv.json, null, cv);

    this.onScenarioUnlock();

    if (!newScenario.isReady()) {

      Logger.error(`[ConnectionViewer(${cv.u})] Could not read scenario: ` + newScenario.getError());
      cv.error(`Can not build scenario from JSON.`);

      return ;
    }

    cv.scenario = newScenario;

    Logger.debug(`[ConnectionViewer(${cv.u})] scenario created dp=${cv.decisionPoint}: `, cv.scenario);

    /* success */

    setTimeout( (): void => {

      cv.setScenario(cv.scenario, cv.decisionPoint);

      /* let any user of this component know that we have reloaded the view */

      cv.reloaded();

    }, 600);

  }

  /** handle a change in the selected decision point */
  public dpChangeEvent(): void {

    let cv: ConnectionViewerComponent = this;

    if (cv.selectedDP) {

      cv.selectMile(cv.selectedDP);

    }

  }

  /** move to the next (more easterly decision point) */
  public moveEast(): void {

    let cv: ConnectionViewerComponent = this;

    if (!cv.selectedDP || cv.decisionPoints.length == 0) {

      /* nothing to view */

      return ;
    }

    let pos: number = cv.decisionPoints.findIndex((x: DecisionPoint): boolean => x == this.selectedDP);

    if (pos < 0) {

      /* can't find the selection? */

      return ;
    }

    pos = ((pos - 1) >= 0) ? (pos - 1) : 0;

    if (cv.decisionPoints[pos] == cv.selectedDP) {

      /* already there. */

      return ;

    }

    Logger.debug(`viewer moving east...`);

    cv.selectMile(cv.decisionPoints[pos]);
  }

  /** move to the previous (more western decision point) */
  public moveWest(): void {

    let cv: ConnectionViewerComponent = this;

    if (!cv.selectedDP || cv.decisionPoints.length == 0) {

      /* nothing to view */

      return ;
    }

    let pos: number = cv.decisionPoints.findIndex((x: DecisionPoint): boolean => x == this.selectedDP);

    if (pos < 0) {

      /* can't find the selection? */

      return ;
    }

    pos = ((pos + 1) < cv.decisionPoints.length) ? (pos + 1) : ( cv.decisionPoints.length - 1);

    if (cv.decisionPoints[pos] == cv.selectedDP) {

      /* already there. */

      return ;
    }

    Logger.debug(`viewer moving west...`);

    cv.selectMile(cv.decisionPoints[pos]);
  }

  /** move all the way west */
  public moveWestEnd(): void {

    let cv: ConnectionViewerComponent = this;

    if (cv.decisionPoints.length == 0) {

      /* nothing to view */

      return ;
    }

    if (cv.decisionPoints[cv.decisionPoints.length - 1] == cv.selectedDP) {

      /* already there. */

      return ;
    }

    Logger.debug(`viewer moving (end) west...`);

    cv.selectMile(cv.decisionPoints[cv.decisionPoints.length - 1]);
  }

  /** move all the way east */
  public moveEastEnd(): void {

    let cv: ConnectionViewerComponent = this;

    if (cv.decisionPoints.length == 0) {

      /* nothing to view */

      return ;
    }

    if (cv.decisionPoints[0] == cv.selectedDP) {

      /* already there. */

      return ;
    }

    Logger.debug(`viewer moving (end) east...`);

    cv.selectMile(cv.decisionPoints[0]);
  }

  /** select a new decision point to show the connection view of */
  public selectMile(decisionPoint: DecisionPoint): void {

    let cv: ConnectionViewerComponent = this;

    Logger.debug(`ConnectionViewer(${cv.u}) - selectMile - new DP: `, decisionPoint);

    /* do we need to set up the drawing framework? */

    if (!cv.canvas) {

      cv.initCanvas();
    }
    /* refresh the connection viewer */

    this.clear();

    cv.selectedDP = decisionPoint;

    if (!cv.selectedDP || !cv.canvas) {

      /* there is nothing to render, or nothing to render to */

      return ;
    }

    /**
     * make an initial version of the highlight manager; it won't have the
     * tracks and connections yet, but we can reference it when building up
     * our objects.
     *
     */

    this.highlightManager = new HighLightManager(
      cv.selectedDP,
      cv.eastSide?.labels() ?? [],
      cv.westSide?.labels() ?? [],
      cv.junctions?.labels() ?? [],
      Array.from(cv.routes.values()),
      cv.colorSpeed);

    if (cv.canvas) {

      cv.canvas.highlighter = this.highlightManager;
    }

    /* the east and west side tracks */

    cv.makeEastWestSide();

    /* junctions block */

    cv.makeJunctions();

    /* connection web */

    cv.makeRoutes();

    /*
     * now that we have all the track and connection objects, we can add
     * everything to the highlight manager, which allows events on any
     * object to lead to global highlighting of any related objects.
     *
     */

    cv.highlightManager?.set(

      cv.eastSide?.labels() ?? [],
      cv.westSide?.labels() ?? [],
      cv.junctions?.labels() ?? [],
      Array.from(cv.routes.values())

    );

  }

  private makeEastWestSide(): void {

    let cv: ConnectionViewerComponent  = this;

    if (!cv.selectedDP || !cv.canvas) {

      /* there is nothing to render, or nothing to render to */

      return ;
    }

    Logger.debug(`ConnectionViewer(${cv.u}) - makeEastWestSide - building ...`);

    /*
     * generally, we just want the non-junction tracks on each side.  But...if
     * we are at one end of the network, then one side will be missing, so we
     * flip the direction and use the "previous" decision point to fill in
     * the missing (other) side.
     *
     */

    let eastTracks: Track[] = cv.selectedDP?._eastSide?._tracks ?? [];
    let westTracks: Track[] = cv.selectedDP?._westSide?._tracks ?? [];

    /* do we need to override because we are at the east end? */

    if (!cv.selectedDP._eastSide) {

      /* use the west side tracks from this decision point as the east tracks */

      eastTracks = westTracks;

      /* use the east side tracks of westward decision point as the west side tracks */

      let previous: DecisionPoint|null = cv.selectedDP.previous(TrainDirection.EAST);

      if (!previous) {

        Logger.error(`ConnectionViewer(${cv.u}) - selectMile - can find next to last east decision point.`);

        return ;
      }

      westTracks = previous._eastSide?._tracks ?? [];
    }

    /* do we need to override because we are at the west end? */

    if (!cv.selectedDP._westSide) {

      /* use the east side tracks from this decision point as the west tracks */

      westTracks = eastTracks;

      /* use the west side tracks of eastward decision point as the east side tracks */

      let previous: DecisionPoint|null = cv.selectedDP.previous(TrainDirection.WEST);

      if (!previous) {

        Logger.error(`ConnectionViewer(${cv.u}) - selectMile - can find next to last west decision point.`);

        return ;
      }

      eastTracks = previous._westSide?._tracks ?? [];
    }

    eastTracks = eastTracks.filter((x: Track): boolean => {
      return x._type != TrackType.JUNCTION && x._type != TrackType.UNKNOWN;
    });

    westTracks = westTracks.filter((x: Track): boolean => {
      return x._type != TrackType.JUNCTION && x._type != TrackType.UNKNOWN;
    });

    /*
     * ok, at ths point we have the east side and the west side tracks...we can
     * make the track blocks...
     *
     */

    Logger.debug(`ConnectionViewer(${cv.u}) - selectMile - building east block...`, eastTracks);

    cv.eastSide = new LinkBlock(
      cv.canvas,
      this.highlightManager,
      eastTracks,
      {
        title: 'East Side',
        orientation: LinkBlockOrientation.RIGHT
      }
    );

    Logger.debug(`ConnectionViewer(${cv.u}) - selectMile - building west block...`, westTracks);

    cv.westSide = new LinkBlock(
      cv.canvas,
      this.highlightManager,
      westTracks,
      {
        title: 'West Side',
        orientation: LinkBlockOrientation.LEFT
      }
    );

  }

  private makeJunctions(): void {

    let cv: ConnectionViewerComponent = this;

    if (!cv.selectedDP || !cv.canvas) {

      /* there is nothing to render, or nothing to render to */

      return ;
    }

    Logger.debug(`ConnectionViewer(${cv.u}) - makeJunctions - building ...`);

    let junctionEast: Track[] = [];
    let junctionWest: Track[] = [];

    if (cv.selectedDP._eastSide) {

      junctionEast = cv.selectedDP._eastSide._tracks;
    }

    if (cv.selectedDP._westSide) {

      junctionWest = cv.selectedDP._westSide._tracks;
    }

    let junctions: Track[] = [
      ...junctionEast.filter((x: Track): boolean => {
        return x._type == TrackType.JUNCTION;
      }),
      ...junctionWest.filter((x: Track): boolean => {
        return x._type == TrackType.JUNCTION;
      })
    ];

    if (junctions.length > 0) {

      /*
       * sometimes junctions are duplicated in the wrong interlink (it's an issue in
       * the scenario or in the JSON.  Do a scan for connections...if the junction
       * is not a to/from of any connection...we just ignore it.
       *
       */

      let toRemove: Track[] = [];

      junctions.forEach((junction: Track): void =>{

        let found: boolean = false;

        for (let [, v] of cv.selectedDP._connections.entries()) {

          if (v._from) {

            if (v._from._id == junction._id) {

              found = true;

              break;
            }
          }

          if (v._to) {

            if (v._to._id == junction._id) {

              found = true;

              break;
            }
          }
        }

        /* did we find any connections to the junction? */

        if (found) {

          return ;
        }

        /* nope! */

        toRemove.push(junction);
      });

      /* remove anything in toRemove from junctions */

      junctions = junctions.filter( ( x: Track ) => !toRemove.includes(x));

      if (junctions.length > 0) {

        /* just the junctions ... */

        Logger.debug(`ConnectionViewer(${cv.u}) - makeJunctions - building junction block...`);

        cv.junctions = new LinkBlock(
          cv.canvas,
          this.highlightManager,
          junctions,
          {
            title: 'Junctions',
            orientation: LinkBlockOrientation.TOP,
          }
        );

      } else {

        cv.junctions = null;
      }

    } else {

      cv.junctions = null;
    }

  }

  private makeRoutes(): void {

    let cv: ConnectionViewerComponent  = this;

    if (!cv.selectedDP || !cv.canvas) {

      /* there is nothing to render, or nothing to render to */

      return ;
    }

    Logger.debug(`ConnectionViewer(${cv.u}) - makeRoutes - building ...`);

    /*
     * add the connection web; we have to walk through the connections,
     * and figure out which ones are linked from which block to which block
     * via track and port.  Once we know the two and from port...we can
     * make the route, and it will take over from there.
     *
     */

    for (let [k, v] of cv.selectedDP._connections.entries()) {

      if (!v._from || !v._to) {

        Logger.error(`ConnectionViewer(${cv.u}) - makeRoutes - connection is missing its to or from track (${v._id}), will skip.`);

        continue ;
      }

      let from: Port|null = cv.findPort(v._from);
      let to: Port|null   = cv.findPort(v._to);

      if (!from) {


        Logger.error(`ConnectionViewer(${cv.u}) - makeRoutes - connection ${v._id}) - can't find port for 'from' (${v._from._id}), will skip.`);

        continue;
      }

      if (!to) {

        Logger.error(`ConnectionViewer(${cv.u}) - makeRoutes - connection ${v._id}) - can't find port for 'to' (${v._to._id}), will skip.`);

        continue;
      }

      /* ok, we have everything we need, build the route */

      let route: Route = new Route(cv.canvas, this.highlightManager, {
        id:       v._id,
        parallel: v._parallel,
        src:      v._from,
        dst:      v._to,
        speed:    v._speed,
        from,
        to,
        color:   'dimgrey'
      });

      cv.routes.set(k, route);

    }

  }

  /** loop over the blocks looking for the port that is tied to this link/track */
  private findPort(id: number | Track): Port|null {

    let cv: ConnectionViewerComponent  = this;
    let port: Port|null       = null;

    /* try junctions... */

    if (cv.junctions) {

      port = cv.junctions.portForTrack(id);
    }

    /* try east side */

    if (!port && cv.eastSide) {

      port = cv.eastSide.portForTrack(id);
    }

    /* try west side */

    if (!port && cv.westSide) {

      port = cv.westSide.portForTrack(id);
    }

    /* no match */

    return port;
  }

  /** first time setup of the canvas */
  private initCanvas(): void {

    let cv: ConnectionViewerComponent  = this;
    const wrapperId: string   = `connection-viewer-wrapper-${cv.u}`;
    let el: Element|null      =  document.querySelector(`#${wrapperId}`);

    Logger.debug(`ConnectionViewer(${cv.u}) - initializing canvas (w: ${el?.clientWidth}, h: ${el?.clientHeight})...`);

    /* create the canvas that our objects will render to ... */

    cv.canvas = new KonvaCanvas({
      container:   `connection-viewer-canvas-${cv.u}`,
      width:       el?.clientWidth  ?? 0,
      height:      el?.clientHeight ?? 0,
      keyListener: this
    });

  }

  /** fetch the current theme */
  public theme(): Theme {

    let cv: ConnectionViewerComponent = this;

    if (cv.configService.getDarkMode(cv.u)) {

      return cv.configService.getDarkModeTheme(cv.u);
    }

    return cv.configService.getLightModeTheme(cv.u);
  }

  /**
   * force the HUG on or off
   *
   * @param flag boolean
   */
  public setHUDMode(flag: boolean): ConnectionViewerComponent {

    let cv: ConnectionViewerComponent = this;

    if (flag == cv.hud) {

      /* already set */

      return this;
    }

    Logger.debug(`[ConnectionViewer(${cv.u}) - setting HUD ${cv.hud} => ${flag}...`);

    cv.hud = flag;

    return this;
  }

  /**
   * force spike lines on/off
   *
   * @param flag boolean
   */
  public setSpikeLinesMode(flag: boolean): ConnectionViewerComponent {

    let cv: ConnectionViewerComponent = this;

    if (flag == cv.spikelines) {

      /* already set */

      return this;
    }

    Logger.debug(`ConnectionViewer(${cv.u})- setting spikes ${cv.spikelines} => ${flag}...`);

    cv.spikelines = flag;

    return this;
  }

  /**
   *
   * @param scenario the new scenario model
   * @param dp       (otional) decision point to focus on
   *
   */
  public setScenario(scenario: Scenario, dp: string = ''): ConnectionViewerComponent {

    let cv: ConnectionViewerComponent = this;
    let dragOverlayId: string       = `connection-viewer-drag-and-drop-${cv.u}`;
    let dropOvly: HTMLElement|null  = $(`#${dragOverlayId}`).get(0) ?? null;

    Logger.debug(`ConnectionViewer(${cv.u}) - setScenario - focus dp='${dp}'.`);

    /* move to showing progress overlay or the actual rendering overlay */

    $(dropOvly).css('display', 'none');

    cv.scenarioFile = null;
    cv.scenario     = scenario;

    /*
     * we've established the scenario, pre-scan the decision points and connection routing,
     * into objects that are more useful to us in this viewer.  Everything we need to draw
     * the connection diagram for a given decision point...is in the details of each
     * decision point.  We just need a list of the decision points that we can select
     * from; on selection we refresh the diagram.
     *
     */

    Logger.debug(`ConnectionViewer(${cv.u}) - setScenario - pre-scanning decision points...`);

    cv.decisionPoints = cv.scenario.milePoints();

    /*
     * the scenario gives decision points ordered with high mile at the end, we want high mile at
     * the start.
     *
     */

    cv.decisionPoints.reverse();

    Logger.debug(`ConnectionViewer(${cv.u}) - setScenario - decisionPoints: `, cv.decisionPoints);

    /* by default view the first decision point (most easterly) */

    if (cv.decisionPoints.length > 0) {

      cv.selectedDP = cv.decisionPoints[0];
    }

    /* but, if they named a decision point...then view that one from the start... */

    this.decisionPoints.forEach((x: DecisionPoint): void => {

      dp = dp.trim();

      if (x._name.trim() == dp) {

        cv.selectedDP = x;

      }

    });

    let savedDP: DecisionPoint = cv.selectedDP;

    Logger.debug(`ConnectionViewer(${cv.u}) - setScenario - default selection: `, savedDP);

    /*
     * select the decision point in the next event cycle, so that the drop down component isn't
     * fighting with us for which thing to view.
     *
     */

    setTimeout((): void => {

      if (savedDP) {

        cv.selectMile(savedDP);
      }

    }, 200);


    return this;
  }

  /**
   * force the scenario to use for decision points
   *
   * @param file File the input to use
   */
  public setFile(file: File|null): ConnectionViewerComponent {

    let cv: ConnectionViewerComponent = this;

    if (!file && !cv.scenarioFile) {

      /* we aren't using a dropped file */

      return this;
    }

    /* if we are already viewing this file...we don't need to do anything. */

    if (file && cv.scenarioFile && file == cv.scenarioFile) {

      return this;
    }

    if (file && cv.scenarioFile && cv.scenarioFile.name == file.name && cv.scenarioFile.size == file.size) {

      /* similar file */

      return this;
    }

    /* files must be read in asynchronously, so we have to convert to a promise... */

    if (!file) {

      /* just reset */

      cv.reset();

      return this;
    }

    Logger.debug(`ConnectionViewer(${cv.u}) - setting new file: ${file.name}: `);

    let obs: Observable<Object> = new Observable((sub: Subscriber<string>): void => {

      Logger.debug(`ConnectionViewer(${cv.u}) - . . new observer: ${file.name}: `);

      const fileReader: FileReader = new FileReader();

      /* when the read is completed */

      fileReader.onload = (ev: ProgressEvent<FileReader>): void => {

        /* save our own mapping of the sample data */

        Logger.debug(`ConnectionViewer(${cv.u} - loaded sz=${ (<any>ev.target).result.length}`);

        sub.next( (<any>ev.target).result );

        sub.complete();
      }

      /* when the read fails */

      fileReader.onerror = (error: ProgressEvent<FileReader>): void => {

        sub.error(error);
      };

      /* trigger the file reading (asynchronously) ... */

      fileReader.readAsText(file);

    });

    obs.subscribe({

      next: (value: object): void => {

        Logger.debug(`ConnectionViewer(${cv.u}) - converting JSON ... `);

        try {

          let data: any          = JSON.parse((value as unknown) as string);
          let scenario: Scenario = new Scenario(data);

          if (!scenario.isReady()) {

            Logger.error(`ConnectionViewer(${cv.u}) - can not recover scenario: ` + cv.scenario.getError());

            return ;
          }

          setTimeout( () => {

            cv.setScenario(scenario, cv.decisionPoint)

            /* let any user of this component know that we have reloaded the view */

            cv.reloaded();

          }, 100);

        } catch (e) {

          /* weird exception */

          Logger.error(`ConnectionViewer(${cv.u}) - exception trying to set file: `, errorAsText(e));
        }

      },
      error: (error: any): void => {

        /* general error */

        Logger.error(`ConnectionViewer(${cv.u}) - error trying to set file: `, errorAsText(error));
      },

      complete: (): void => {

        Logger.debug(`ConnectionViewer(${cv.u}) - setting file completed.`);
      }

    });

    return this;
  }

  /** get ready for a new decision point to be displayed */
  public clear(): ConnectionViewerComponent {

    let cv: ConnectionViewerComponent = this;

    cv.eastSide         = null;
    cv.westSide         = null;
    cv.junctions        = null;
    cv.routes           = new Map<number, Route>();
    cv.highlightManager = null;

    if (cv.canvas) {

      cv.canvas.clear();

      cv.canvas.highlighter = null;
    }

    return this;
  }

  /** reset the viewer */
  public reset(): ConnectionViewerComponent {

    let cv: ConnectionViewerComponent = this;

    cv.scenario       = null;
    cv.decisionPoints = [];
    cv.selectedDP     = null;

    this.clear();

    return this;
  }

  /** apply any hover style override (ignore if object is clicked) */
  public onKey(event: KeyboardEvent): void {

    Logger.debug(`viewer keyboard event: `, event as KeyboardEvent);

    let cv: ConnectionViewerComponent = this;

    /* if they use the left or right cursor keys, navigate west / east in the network */

    if (event.key == 'ArrowDown') {

      cv.moveWest();

    } else if (event.key == 'ArrowUp') {

      cv.moveEast();

    } else if (event.key == 'ArrowLeft') {

      cv.moveWestEnd();

    } else if (event.key == 'ArrowRight') {

      cv.moveEastEnd();
    }

  }
}
